export default {
  ApiBaseUrl: process.env.VUE_APP_API_BASE_URL,
  serverBaseUrl: process.env.VUE_APP_BASE_URL,
}
